import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaInstagram, FaMapMarkerAlt, FaCertificate, FaChevronLeft, FaChevronRight, FaGlobe } from 'react-icons/fa';
import './Alojamientos.css';

// Importar imágenes de Alquería Las Torres
import alqueriaMain from '../../Images/alqueria/IMG1.webp'; // Imagen principal
import alqueria1 from '../../Images/alqueria/alqueria1.webp';
import alqueria2 from '../../Images/alqueria/alqueria2.webp';
import alqueria3 from '../../Images/alqueria/alqueria3.webp';
import alqueria4 from '../../Images/alqueria/alqueria4.webp';
import alqueria5 from '../../Images/alqueria/alqueria5.webp';
import alqueria6 from '../../Images/alqueria/alqueria6.webp';
import alqueria7 from '../../Images/alqueria/alqueria7.webp';
import alqueria8 from '../../Images/alqueria/alqueria8.webp';
import alqueria9 from '../../Images/alqueria/alqueria9.webp';

// Importar imágenes de Hispanidad (optimizadas para móviles)
import hispanidadTarjeta from '../../Images/alojamientos/Tarjeta 2 - Jessica Martinez (1).webp';
import hispanidad1 from '../../Images/alojamientos/hispanidad1_optimized.jpg';
import hispanidad2 from '../../Images/alojamientos/hispanidad2_optimized.jpg';
import hispanidad3 from '../../Images/alojamientos/hispanidad3_optimized.jpg';
import hispanidad4 from '../../Images/alojamientos/hispanidad4_optimized.jpg';
import hispanidad5 from '../../Images/alojamientos/hispanidad5_optimized.jpg';
import hispanidad6 from '../../Images/alojamientos/hispanidad6_optimized.jpg';

const Alojamientos = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);    
 
  // Datos de los alojamientos
  const alojamientos = [
    {
      id: 1,
      nombre: "Alquería Las Torres",
      tipo: "Casa Rural",
      descripcion: [
        "4 habitaciones y 5 baños",
        "Cocina totalmente equipada con nevera, microondas, horno, lavadora, cubertería y vajilla",
        "Salón, patio con porche y barbacoa",
        "Piscina en verano",
        "A 20 minutos de Toledo",
        "A 5 minutos de Las Barrancas de Burujón"
      ],
      email: "Reservas@casaruraltoledo.org",
      telefono: "638037396",
      web: "www.casaruraltoledo.org",
      direccion: "Calle Armas, 39. 45517 Escalonilla (Toledo)",
      sector: "Turismo",
      imagenes: [
        alqueriaMain,
        alqueria1,
        alqueria2,
        alqueria3,
        alqueria4,
        alqueria5,
        alqueria6,
        alqueria7,
        alqueria8,
        alqueria9
      ]
    },
    {
      id: 2,
      nombre: "Hispanidad",
      tipo: "Vivienda de Uso Turístico",
      descripcion: [
        "3 habitaciones",
        "2 baños (uno con plato de ducha, otro con bañera)",
        "Cocina equipada con nevera, microondas, horno, lavadora, cubertería y vajilla",
        "A 20 minutos de Toledo",
        "A 5 minutos de Las Barrancas de Burujón"
      ],
      email: "hispanidad.escalonilla@gmail.com",
      telefono: "679768582",
      instagram: "https://www.instagram.com/hispanidad.escalonilla?utm_source=qr&igsh=MW53OXhkMXRtamIxdw==",
      direccion: "Calle Hispanidad, 3. 45517 Escalonilla (Toledo)",
      registroTuristico: "TUR01-4530-2649",
      imagenes: [
        hispanidadTarjeta,
        hispanidad1,
        hispanidad2,
        hispanidad3,
        hispanidad4,
        hispanidad5,
        hispanidad6
      ]
    }
  ];

  const nextImages = (alojamientoId) => {
    const alojamiento = alojamientos.find(a => a.id === alojamientoId);
    const totalImages = alojamiento.imagenes.length;
    setCurrentImageIndex((prevIndexes) => ({
      ...prevIndexes,
      [alojamientoId]: ((prevIndexes[alojamientoId] || 0) + 1) >= totalImages ? 0 : (prevIndexes[alojamientoId] || 0) + 1
    }));
  };

  const prevImages = (alojamientoId) => {
    const alojamiento = alojamientos.find(a => a.id === alojamientoId);
    const totalImages = alojamiento.imagenes.length;
    setCurrentImageIndex((prevIndexes) => ({
      ...prevIndexes,
      [alojamientoId]: (prevIndexes[alojamientoId] || 0) === 0 ? totalImages - 1 : (prevIndexes[alojamientoId] || 0) - 1
    }));
  };

  const getCurrentImage = (alojamientoId) => {
    const alojamiento = alojamientos.find(a => a.id === alojamientoId);
    const imageIndex = currentImageIndex[alojamientoId] || 0;
    return alojamiento.imagenes[imageIndex];
  };

  const setImageIndex = (alojamientoId, index) => {
    setCurrentImageIndex((prevIndexes) => ({
      ...prevIndexes,
      [alojamientoId]: index
    }));
  };

  // Funciones para manejar swipe táctil
  const handleTouchStart = (e) => {
    setTouchEnd(0); // Reset touchEnd
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = (alojamientoId) => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextImages(alojamientoId);
    }
    if (isRightSwipe) {
      prevImages(alojamientoId);
    }
  };

  return (
    <div className="alojamientos-container">
      <div className="container">
        <h1>Alojamientos en Escalonilla</h1>
        <p>Descubre los mejores alojamientos rurales de Escalonilla, perfectos para una escapada tranquila cerca de Toledo y sus principales atracciones turísticas.</p>
        
        <Container>
        {alojamientos.map((alojamiento) => (
          <div key={alojamiento.id} className="alojamiento-section">
            <Row>
              <Col md={6}>
                <h2>{alojamiento.nombre}</h2>
                <div className="alojamiento-text">
                  <p><strong>{alojamiento.tipo}</strong></p>
                  <ul className="descripcion-lista">
                    {alojamiento.descripcion.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="contact-info">
                  <h3>Información de Contacto</h3>
                  <div className="contact-item">
                    <FaEnvelope className="contact-icon" />
                    <a href={`mailto:${alojamiento.email}`}>{alojamiento.email}</a>
                  </div>
                  <div className="contact-item">
                    <FaPhone className="contact-icon" />
                    <a href={`tel:${alojamiento.telefono}`}>{alojamiento.telefono}</a>
                  </div>
                  {alojamiento.web && (
                    <div className="contact-item">
                      <FaGlobe className="contact-icon" />
                      <a href={`https://${alojamiento.web}`} target="_blank" rel="noopener noreferrer">
                        {alojamiento.web}
                      </a>
                    </div>
                  )}
                  {alojamiento.instagram && (
                    <div className="contact-item">
                      <FaInstagram className="contact-icon" />
                      <a href={alojamiento.instagram} target="_blank" rel="noopener noreferrer">
                        @hispanidad.escalonilla
                      </a>
                    </div>
                  )}
                  <div className="contact-item">
                    <FaMapMarkerAlt className="contact-icon" />
                    <a 
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(alojamiento.direccion)}`}
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      {alojamiento.direccion}
                    </a>
                  </div>
                  {alojamiento.registroTuristico && (
                    <div className="contact-item">
                      <FaCertificate className="contact-icon" />
                      <span>Registro Turístico: {alojamiento.registroTuristico}</span>
                    </div>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="single-image-carousel">
                  <div className="image-container">
                    <button className="carousel-btn prev-btn" onClick={() => prevImages(alojamiento.id)}>
                      <FaChevronLeft />
                    </button>
                    
                    <div 
                      className="single-image-wrapper"
                      onTouchStart={handleTouchStart}
                      onTouchMove={handleTouchMove}
                      onTouchEnd={() => handleTouchEnd(alojamiento.id)}
                    >
                      <img
                        src={getCurrentImage(alojamiento.id)}
                        alt={`${alojamiento.nombre} - Foto ${(currentImageIndex[alojamiento.id] || 0) + 1}`}
                        className="carousel-image"
                        draggable="false"
                      />
                    </div>
                    
                    <button className="carousel-btn next-btn" onClick={() => nextImages(alojamiento.id)}>
                      <FaChevronRight />
                    </button>
                  </div>

                  <div className="carousel-indicators">
                    {alojamiento.imagenes.map((_, index) => (
                      <button 
                        key={index}
                        className={`indicator ${(currentImageIndex[alojamiento.id] || 0) === index ? 'active' : ''}`}
                        onClick={() => setImageIndex(alojamiento.id, index)}
                      />
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ))}
        </Container>
      </div>
    </div>
  );
};

export default Alojamientos;
